import React, { useState, useEffect, useContext,useRef } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import useHrAccess from "../../hooks/useHrAccess";
import { Button, Form, Offcanvas } from "react-bootstrap";
import FieldHelpTooltip from "../../components/Help/FieldHelpTooltip";
import { HELP_CONTENT } from "../../components/Help/HelpContent";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import PhoneInput from "react-phone-input-2";
import { IoCalendarOutline } from "react-icons/io5";
import { Formik } from "formik";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
import UserContext from "../../components/context/UserContext";
import AppDropdown from "../../components/AppDropdown/AppDropdown";
import { validMobileFormatByOwnPrefixTest } from "../../utils/phoneValidation";
import { getPersonaForRole, PERSONA } from "../../constants/roles";
import SkillSelect from "./SkillSelect";

const EditProfileSidebar = ({ userRole, navigate, show, onHide, doctorData, setDoctorData,updateProvidersList,setIndustry }) => {
              const location = useLocation();
              // Where HR (HRMS) is enabled for this tenant, identity and contact details are owned by the person's
              // HR profile - this form only keeps the booking-specific fields (services, experience, shifts/fee
              // handled in ProviderAvailability.jsx) editable, and points to HR for the rest.
              const { access: hrAccess } = useHrAccess();
              const hrEnabled = !!hrAccess?.enabled;

              console.log(setIndustry)
  // const _ud = (() => {
  //   try {
  //     const d = localStorage.getItem("userDetails");
  //     return d && d !== "undefined" ? JSON.parse(d) : null;
  //   } catch { return null; }
  // })();
const isClinicService = setIndustry?.industry === 1;
const isSportsService = setIndustry?.industry === 7;
const isCarService = setIndustry?.industry === 8;

const providerHelp = {
  name: isClinicService
    ? HELP_CONTENT.editProvider.Doctorname
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProviderName
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderName
    : HELP_CONTENT.editProvider.name,

  gender: isClinicService
    ? HELP_CONTENT.editProvider.Doctorgender
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProvidergender
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProvidergender
    : HELP_CONTENT.editProvider.gender,

  experienceStart: isClinicService
    ? HELP_CONTENT.editProvider.DoctorexperienceStart
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProviderexperienceStart
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderexperienceStart
    : HELP_CONTENT.editProvider.experienceStart,

  services: isClinicService
    ? HELP_CONTENT.editProvider.Doctorservices
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProviderservices
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderservices
    : HELP_CONTENT.editProvider.services,

  uniqueId: isClinicService
    ? HELP_CONTENT.editProvider.DoctoruniqueId
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProvideruniqueId
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProvideruniqueId
    : HELP_CONTENT.editProvider.uniqueId,

  phone: isClinicService
    ? HELP_CONTENT.editProvider.Doctorphone
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProviderphone
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderphone
    : HELP_CONTENT.editProvider.phone,

  country: isClinicService
    ? HELP_CONTENT.editProvider.Doctorcountry
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProvidercountry
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProvidercountry
    : HELP_CONTENT.editProvider.country,

  city: isClinicService
    ? HELP_CONTENT.editProvider.Doctorcity
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProvidercity
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProvidercity
    : HELP_CONTENT.editProvider.city,

  email: isClinicService
    ? HELP_CONTENT.editProvider.Doctoremail
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProvideremail
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProvideremail
    : HELP_CONTENT.editProvider.email,

  state: isClinicService
    ? HELP_CONTENT.editProvider.DoctorState
    : isCarService
    ? HELP_CONTENT.editProvider.ServiceProviderState
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderState
    : HELP_CONTENT.editProvider.state,

  about:isClinicService
    ? HELP_CONTENT.editProvider.Doctorabout
    : isSportsService
    ? HELP_CONTENT.editProvider.SportsProviderabout
    : HELP_CONTENT.editProvider.about

};
  // Backend stores an unset date as the MySQL zero-date "0000-00-00 00:00:00"
  // (e.g. Car Service crew where experience isn't mandatory) — treat that as no date.
  const toValidDateStr = (val) => {
    if (!val) return "";
    const d = new Date(val);
    return isNaN(d.getTime()) ? "" : val;
  };

    const formikRef = useRef();
    const [initLocation, setInitLocation] = useState({ country_id: "", state_id: "", city_id: "" });
      const [educationOptions, setEducationOptions] = useState([]);
      const [serviceId, setServiceId] = useState("");
      const { vendor } = useContext(UserContext);

      useEffect(() => {
        if (vendor && vendor.service) {
          setServiceId(vendor.service);
        }
      }, [vendor]);
    
    const currentSpecializationId =
      doctorData?.specialization_id || doctorData?.specilisation || "";
const [countries, setCountries] = useState([]);

const [states, setStates] = useState([]);
const [cities, setCities] = useState([]);
    const [educationValue, setEducationValue] = useState("");
const [services, setServices] = useState([]);
const [selectedService, setSelectedService] = useState([]);
const [serviceError, setServiceError] = useState(false);
    // A crew member viewing their own profile cannot change their own skill (the server also refuses it).
    const isCrewSelf = getPersonaForRole(apicall.getRole()) === PERSONA.CREW;
    const initialValues = {
      fullName: doctorData?.first_name
        ? `${doctorData.first_name || ""} ${doctorData.last_name || ""}`.trim()
        : `${doctorData?.name || ""} ${doctorData?.last_name || ""}`.trim(),
      gender:
        doctorData?.gender === 1 ||
        doctorData?.gender === "1" ||
        doctorData?.gender === "Male"
          ? "1"
          : doctorData?.gender === 2 ||
            doctorData?.gender === "2" ||
            doctorData?.gender === "Female"
          ? "2"
          : "",
      specialization: currentSpecializationId,
      education: educationValue,
      date_of_birth: toValidDateStr(doctorData?.dob || doctorData?.date_of_birth),
      experience_start_date: toValidDateStr(doctorData?.practice_start),
      about: doctorData?.about_user || "",
      consultation_fees: doctorData?.fee || "",
      phone_number: doctorData?.phone_number || doctorData?.phone || "",
      email: doctorData?.email || "",
      countryIso: "",
      country_id: initLocation.country_id,
      state_id: initLocation.state_id,
      city_id: initLocation.city_id,
      payRoll: doctorData?.pay_roll || "",
      uniqueId: doctorData?.unique_id || "",
      skillKey: doctorData?.skill_key || "PROFESSIONAL",
    };
      const fetchEducationOptions = async () => {
        try {
          const response = await apicall.get(
            `serviceProviderEducation/${serviceId}`
          );
          if (response && response.data) {
            setEducationOptions(response.data);
          }
        } catch (error) {
          console.error("Error fetching education options:", error);
        }
      };
    
const fetchCountries = async () => {
  const res = await apicall.get("ezp_country");
  setCountries(res.data || []);
};

const fetchStates = async (countryId) => {
  const res = await apicall.get(`ezp_state/${countryId}`);
  setStates(res.data || []);
};

const fetchCities = async (stateId) => {
  const res = await apicall.get(`ezp_city/${stateId}`);
  setCities(res.data || []);
};
useEffect(() => {
  fetchCountries();
}, []);
const mapDialCodeToCountry = (dialCode) => {
  if (!countries.length) return null;

  return countries.find((c) => {
    const apiDialCode = c.telephone_code?.replace("+", "");

    return String(apiDialCode) === String(dialCode);
  });
};
const getIsoFromShortName = (shortName) => {
  const map = {
    UAE: "AE",
    IN: "IN",
  };

  return map[shortName] || "IN";
};
    useEffect(() => {
      if (doctorData?.education) {
        // If education is already an ID (numeric)
        if (!isNaN(doctorData.education)) {
          setEducationValue(doctorData.education);
        } else if (educationOptions.length > 0) {
          const edu = educationOptions.find(
            (e) => e.degree_name === doctorData.education
          );
          if (edu) {
            setEducationValue(edu.id);
          } else {
            // If not found, set the name as fallback
            console.log("No education match found, using name as fallback");
            setEducationValue(doctorData.education);
          }
        } else {
          setEducationValue(doctorData.education);
        }
      }
    }, [educationOptions, doctorData?.education]);

    const nameLabel = isCarService
      ? "Service provider"
      : isClinicService
      ? "Doctor"
      : isSportsService
      ? "Coach"
      : "Crew";

    const validationSchema = Yup.object({
      fullName: Yup.string()
        .required(`${nameLabel} name is required`)
        .min(2, `${nameLabel} name must be at least 2 characters`)
        .max(40, `${nameLabel} name cannot exceed 40 characters`),
      gender: (isSportsService || isCarService)
        ? Yup.string()
        : Yup.string().oneOf(["1", "2"], "Please select a valid gender").required("Gender is required"),
      // specialization: Yup.string().required("Specialization is required"),
      // education: Yup.string().required("Education is required"),
      // date_of_birth: Yup.date()
      //   .required("Date of birth is required")
      //   .max(
      //     new Date(
      //       new Date().setFullYear(new Date().getFullYear() - 15) -
      //         24 * 60 * 60 * 1000
      //     ),
      //     "Crew must be at least 15 years old"
      //   )
      //   .min(new Date(1900, 0, 1), "Invalid date of birth"),
      experience_start_date: (isSportsService || isCarService)
        ? Yup.date().nullable()
        : Yup.date()
            .required("Experience start date is required")
            .max(
              new Date(Date.now() - 24 * 60 * 60 * 1000),
              "Experience start date cannot be in the future"
            ),
      // .test(
      //   "after-dob",
      //   "Experience start date must be after date of birth",
      //   function (value) {
      //     const { date_of_birth } = this.parent;
      //     if (!date_of_birth || !value) return true;
      //     return new Date(value) > new Date(date_of_birth);
      //   }
      // ),

      // consultation_fees: Yup.number()
      //   .required("Consultation fees is required")
      //   .positive("Consultation fees must be positive")
      //   .max(10000, "Consultation fees cannot exceed 10,000")
      //   .test(
      //     "fee-range",
      //     `Fee must be between AED ${feeRange.fee_from} and AED ${feeRange.fee_to}`,
      //     function (value) {
      //       if (!feeRange.fee_from || !feeRange.fee_to) return true;
      //       const fee = Number(value);
      //       const from = Number(feeRange.fee_from);
      //       const to = Number(feeRange.fee_to);
      //       return fee >= from && fee <= to;
      //     }
      //   ),
      // email: Yup.string()
      //   .email("Invalid email format")
      //   .required("Email is required")
      //   .max(100, "Email must not exceed 100 characters")
      //   .test(
      //     "email-format",
      //     "Please enter a valid email address",
      //     function (value) {
      //       if (!value) return true;
      //       const emailRegex =
      //         /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      //       return emailRegex.test(value);
      //     }
      //   ),
      // about: Yup.string()
      //   .required("About section is required")
      //   .min(10, "About section must be at least 10 characters")
      //   .max(500, "About section cannot exceed 500 characters"),
      phone_number: Yup.string()
        .required("Mobile Number is required")
        .test("valid-mobile-format", validMobileFormatByOwnPrefixTest()),
      // .matches(/^[0-9]+$/, 'Phone number must contain only digits')
      // .min(9, 'Phone number must be at least 9 digits')
      // .max(15, 'Phone number must not exceed 15 digits')
    });
useEffect(() => {
  get_services();
}, []); 
useEffect(() => {
  if (services.length > 0 && doctorData?.service) {

    let serviceIds = [];

    if (Array.isArray(doctorData.service)) {
      serviceIds = doctorData.service;
    } else if (typeof doctorData.service === "string") {
      serviceIds = doctorData.service
        .split(",")
        .map((id) => Number(id.trim()))
        .filter(Boolean);
    } else if (typeof doctorData.service === "number") {
      serviceIds = [doctorData.service];
    }


    const preselected = services.filter((s) =>
      serviceIds.includes(Number(s.id))
    );


    setSelectedService(preselected);
  }
}, [services, doctorData]);

  const fetchDoctorById = async (doctorId) => {
    const response = await apicall.get(
      `get_ezp_service_providers?user_id=${doctorId}`
    );
    if (response && response.status === 200 && Array.isArray(response.data)) {
      const doc = response.data[0];
      if (!doc) return null;
      let genderValue = "2";
      if (doc.gender === 1 || doc.gender === "1" || doc.gender === "Male")
        genderValue = "1";
      if (doc.gender === 2 || doc.gender === "2" || doc.gender === "Female")
        genderValue = "2";
      return {
        ...doc,
        gender: genderValue,
        name: `${doc.first_name || ""} ${doc.last_name || ""}`.trim(),
        specialization: doc.specilisation_name || doc.specialization,
        specialization_id: doc.specilisation_id || doc.specilisation,
        rating: doc.average_rating ?? 0,
        experience: doc.practice_start
          ? `${
              new Date().getFullYear() -
              new Date(doc.practice_start).getFullYear()
            } Years Experience`
          : "",
        reviews: doc.total_bookings ?? 0,
      };
    }
    return null;
  };
    const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
      try {
        // Nothing changed — don't hit the API or reload the page for a
        // no-op save, just let the user know.
        const baseline = { ...initialValues, education: educationValue };
        const hasFieldChange = Object.keys(baseline).some(
          (key) => String(values[key] ?? "") !== String(baseline[key] ?? "")
        );

        let expectedServiceIds = [];
        if (Array.isArray(doctorData?.service)) {
          expectedServiceIds = doctorData.service.map(Number);
        } else if (typeof doctorData?.service === "string") {
          expectedServiceIds = doctorData.service
            .split(",")
            .map((id) => Number(id.trim()))
            .filter(Boolean);
        } else if (typeof doctorData?.service === "number") {
          expectedServiceIds = [doctorData.service];
        }
        const currentServiceIds = selectedService.map((s) => Number(s.id));
        const hasServiceChange =
          expectedServiceIds.length !== currentServiceIds.length ||
          expectedServiceIds.some((id) => !currentServiceIds.includes(id));

        if (!hasFieldChange && !hasServiceChange) {
          toast.info("No changes detected");
          setSubmitting(false);
          return;
        }

        // Additional client-side validation
        if (!values.fullName.trim()) {
          setFieldError("fullName", `${nameLabel} name cannot be empty`);
          return;
        }
const serviceIds = selectedService.map((s) => s.id);
        const [firstName, ...lastNameParts] = values.fullName.trim().split(" ");
        const lastName = lastNameParts.join(" ");

        // NOTE: the backend's edit_availability handler currently only
        // persists appointment_duration/no_of_slots/shifts — it doesn't
        // read or save country_id/state_id/city_id (or several of the
        // other fields below) at all. Sending them here is a no-op until
        // that's fixed server-side. Using the encrypted dropdown ids
        // (values.country_id/state_id/city_id) to match what create_user
        // expects, for when this does get wired up.
        const payload = {
          user_id: doctorData.id,
          first_name: firstName,
          last_name: lastName,
          gender: Number(values.gender),
          phone_number: values.phone_number,
         country_id: values.country_id || null,
state_id: values.state_id || null,
city_id: values.city_id || null,
          // dob: new Date(values.date_of_birth).toISOString().split("T")[0],
          dob: new Date().toISOString().split("T")[0],
          practice_start: values.experience_start_date
            ? new Date(values.experience_start_date).toISOString().split("T")[0]
            : null,
          about_user: values.about?.trim() || "",
          fee: values.consultation_fees,
          specilisation: values.specialization,
          is_active: doctorData.is_active,
          education: values.education,
             services: serviceIds,
      payRoll: values.payRoll,
      uniqueId: values.uniqueId,
        };
        // Only sent when it changed, and the server only honours it from owner/admin/support.
        if (values.skillKey !== initialValues.skillKey) payload.skill_key = values.skillKey;

        if (values.email !== doctorData.email) {
          payload.email = values.email.trim();
        }

        const response = await apicall.post(payload, "updateProvider");
        if (response.status === 200) {
          toast.success("Profile updated successfully");
          // Fetch the latest doctor data
          const updatedDoctor = await fetchDoctorById(doctorData.id);
          if (updatedDoctor) {
            setDoctorData(updatedDoctor);
          }
          onHide();
        //   setShowEditSidebar(false);
          // Reload after a delay so the success toast is visible before the
          // full page reload wipes it out.
          setTimeout(() => window.location.reload(), 2000);
        } else {
          toast.error(response.message || "Failed to update profile");
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        if (error.response?.data?.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Failed to update profile. Please try again.");
        }
      } finally {
        setSubmitting(false);
      }
    };
const get_services = async () => {
  try {
    const response = await apicall.get("get_ezp_service");
    if (response.status === 200) {
      const list = response.data.map((s) => ({
        id: s.service_id,
        name: s.service_name,
      }));
      setServices(list);
    }
  } catch (err) {
    console.error(err);
  }
};
  useEffect(() => {
    const savedProviderDetails = sessionStorage.getItem("providerDetails");
    if (savedProviderDetails) {
      const parsedDetails = JSON.parse(savedProviderDetails);

      let s1 = [];
      for (let i of parsedDetails.service) {
        for (let j of services) {
          if (j.id === i) {
            s1.push({ id: j.id, name: j.name });
          }
        }
      }
      setSelectedService(s1);
      // console.log("parsedDetails---", parsedDetails);
      // console.log("services---", services);
      // if (parsedDetails.service) {
      //   setSpecializationName(parsedDetails.service);
      // }
     
    }
  }, [services]);
// Sets only the phone flag (countryIso) — location fields are handled by the preload below
useEffect(() => {
  if (!doctorData?.phone_number || !countries.length || !formikRef.current) return;
  const phone = doctorData.phone_number;
  let dialCode = "";
  if (phone.startsWith("971")) dialCode = "971";
  else if (phone.startsWith("91")) dialCode = "91";
  const matchedCountry = mapDialCodeToCountry(dialCode);
  if (matchedCountry) {
    setTimeout(() => {
      formikRef.current?.setFieldValue(
        "countryIso",
        (matchedCountry.iso2 || matchedCountry.country_code || "").toUpperCase()
      );
    }, 0);
  }
}, [countries, doctorData]);

// Reset when provider changes so stale location from a previous provider is cleared
useEffect(() => {
  setInitLocation({ country_id: "", state_id: "", city_id: "" });
  setStates([]);
  setCities([]);
}, [doctorData?.id]);

// Pre-populate country/state/city dropdowns.
// The dropdown APIs return encrypted IDs that never match the raw numeric IDs stored
// in the backend, so we match by name and use the encrypted ID from the dropdown list.
// All three values are set in one batch so Formik's enableReinitialize gets a single
// clean initialValues update instead of partial resets.
useEffect(() => {
  if (!show || !countries.length || !doctorData?.country_name) return;

  const preload = async () => {
    try {
      const countryMatch = countries.find(
        (c) =>
          (c.name || c.country_name)?.toLowerCase() ===
          doctorData.country_name?.toLowerCase()
      );
      if (!countryMatch) return;

      const countryId = countryMatch.id;
      const stateRes = await apicall.get(`state/${countryId}`);
      const stateList = stateRes.data || [];

      let stateId = "";
      let cityList = [];
      if (doctorData.state_name) {
        const stateMatch = stateList.find(
          (s) =>
            (s.name || s.state_name)?.toLowerCase() ===
            doctorData.state_name?.toLowerCase()
        );
        if (stateMatch) {
          stateId = stateMatch.id;
          const cityRes = await apicall.get(`city/${stateId}`);
          cityList = cityRes.data || [];
        }
      }

      let cityId = "";
      if (doctorData.city_name && cityList.length) {
        const cityMatch = cityList.find(
          (c) =>
            (c.name || c.city_name)?.toLowerCase() ===
            doctorData.city_name?.toLowerCase()
        );
        if (cityMatch) cityId = cityMatch.id;
      }

      // One batch → one render → one enableReinitialize update with all three fields
      setInitLocation({ country_id: countryId, state_id: stateId, city_id: cityId });
      setStates(stateList);
      setCities(cityList);
    } catch (e) {
      // preload failed silently
    }
  };

  preload();
}, [show, countries, doctorData?.id]);
    return (
      <Offcanvas
        show={show}
        // onHide={() => setShowEditSidebar(false)}
          onHide={onHide}

        placement="end"
        style={{ width: "500px" }}
      >
        <Offcanvas.Header closeButton className="custom-border-bottom p-4">
          <Offcanvas.Title className="page-heading">
            Edit Profile
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="p-4">
            <Formik
              key={doctorData?.id + "_" + doctorData?.updated_at} 

              innerRef={formikRef}

              initialValues={{
                ...initialValues,
                education: educationValue,
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            //   key={educationValue}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
                setFieldTouched,
                submitForm,
              }) => (
                <>
                  <Form onSubmit={handleSubmit} id="edit-profile-form">
                    <div className="mb-4">
                      <h6 className="profile-section-heading mb-3">
                        Personal Details
                      </h6>
                      {hrEnabled && (
                        <div className="text-muted mb-3" style={{ fontSize: 13 }}>
                          Name, gender and contact details are managed in this person's HR profile.{" "}
                          {doctorData?.user_id ? (
                            <Link to={`/hr/employees/${doctorData.user_id}`}>View in HR</Link>
                          ) : null}
                        </div>
                      )}
                      {!hrEnabled && (
                      <Form.Group className="mb-3">
                        <Form.Label>
  {isCarService
    ? "Service Provider Name"
    : isClinicService
    ? "Doctor Name"
    : isSportsService
    ? "Coach Name"
    : "Crew Name"}
  <FieldHelpTooltip {...providerHelp.name} />
</Form.Label>
                        <Form.Control
                          type="text"
                          name="fullName"
                          value={values.fullName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${
                            touched.fullName && errors.fullName
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder={`Enter ${nameLabel.toLowerCase()} name`}
                        />
                        {touched.fullName && errors.fullName && (
                          <div className="invalid-feedback d-block">
                            {errors.fullName}
                          </div>
                        )}
                      </Form.Group>
                      )}

                      {!isSportsService && !hrEnabled && (
                      <Form.Group className="mb-3">
                        <Form.Label>Gender <FieldHelpTooltip {...providerHelp.gender} /></Form.Label>
                        <AppDropdown
                          value={values.gender}
                          options={[{label:"Male", value:"1"}, {label:"Female", value:"2"}]}
                          onChange={(e) => { setFieldValue("gender", e.value); setFieldTouched("gender", true, false); }}
                          error={touched.gender && errors.gender}
                          placeholder="Choose Gender"
                        />
                        {touched.gender && errors.gender && (
                          <div className="invalid-feedback d-block">
                            {errors.gender}
                          </div>
                        )}
                      </Form.Group>
                      )}

                      <SkillSelect
                        className="mb-3"
                        value={values.skillKey}
                        onChange={(v) => setFieldValue("skillKey", v)}
                        disabled={isCrewSelf}
                      />

                      {!isSportsService && (
                      <Form.Group className="mb-3">
                        <Form.Label>Experience Started On <FieldHelpTooltip {...providerHelp.experienceStart} /></Form.Label>
                        <div className="position-relative">
                          <DatePicker
                            selected={
                              values.experience_start_date
                                ? new Date(values.experience_start_date)
                                : null
                            }
                            onChange={(date) =>
                              setFieldValue("experience_start_date", date)
                            }
                            onBlur={handleBlur}
                            dateFormat="yyyy-MM-dd"
                            maxDate={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                            className={`form-control form-input ${
                              touched.experience_start_date &&
                              errors.experience_start_date
                                ? "is-invalid"
                                : ""
                            }`}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Select Date"
                          />
                          <IoCalendarOutline
                            className="position-absolute end-1 top-50 translate-middle-y pe-none"
                            style={{
                              right:
                                errors.experience_start_date &&
                                touched.experience_start_date
                                  ? "1.75rem"
                                  : "0.75rem",
                            }}
                          />
                        </div>
                        {touched.experience_start_date &&
                          errors.experience_start_date && (
                            <div className="invalid-feedback d-block">
                              {errors.experience_start_date}
                            </div>
                          )}
                      </Form.Group>
                      )}

                      <Form.Group className="mb-3">
                        <Form.Label>About You <FieldHelpTooltip {...providerHelp.about} /></Form.Label>
                        <Form.Control
                          as="textarea"
                          name="about"
                          rows={3}
                          value={values.about}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${
                            touched.about && errors.about ? "is-invalid" : ""
                          }`}
                          placeholder="Tell us about yourself..."
                        />
                        {touched.about && errors.about && (
                          <div className="invalid-feedback d-block">
                            {errors.about}
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>{isClinicService ? "Select Specialization" : isSportsService ? "Sports" : "Services"} <FieldHelpTooltip {...providerHelp.services} /></Form.Label>
                      
                    <div
>
  <MultiSelect
    value={selectedService}
    onChange={(e) => {
      setSelectedService(e.value);
      setServiceError(false);
    }}
    options={services}
    optionLabel="name"
    filter
    placeholder={isClinicService ? "Select Specialization" : isSportsService ? " Select Sports" : "Select Services"}
    maxSelectedLabels={3}
    style={{ width: "100%", height: "40px" }}
  />
</div>
                      </Form.Group>
                      {!isClinicService && !isSportsService &&(
                               <Form.Group className="mb-3">
                        <Form.Label>Payroll <FieldHelpTooltip {...providerHelp.payroll} /></Form.Label>
                        <Form.Control
                          type="text"
                          name="payRoll"
                          value={values.payRoll}
                             onChange={handleChange}
                        />
                      </Form.Group>
                      )}
               
                      
                      <Form.Group className="mb-3">
                        <Form.Label>Unique ID <FieldHelpTooltip {...providerHelp.uniqueId} /></Form.Label>
                        <Form.Control
                          type="text"
                          name="uniqueId"
                          value={values.uniqueId}
                                                    onBlur={handleBlur}
                        />
                      </Form.Group>

                      {/* <Form.Group className="mb-3">
                        <Form.Label>Consultation Fees</Form.Label>
                        <Form.Control
                          type="number"
                          name="consultation_fees"
                          value={values.consultation_fees}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${
                            touched.consultation_fees &&
                            errors.consultation_fees
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Enter consultation fees"
                          min="0"
                          max="10000"
                        />
                        {feeRange.fee_from && feeRange.fee_to && (
                          <small className="text-muted">
                            Range: AED {feeRange.fee_from} - {feeRange.fee_to}
                          </small>
                        )}
                        {touched.consultation_fees &&
                          errors.consultation_fees && (
                            <div className="invalid-feedback d-block">
                              {errors.consultation_fees}
                            </div>
                          )}
                      </Form.Group> */}
                    </div>

                    {!hrEnabled && (
                    <div className="mb-4">
                      <h6 className="profile-section-heading mb-3">
                        Contact Details
                      </h6>
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile Number <FieldHelpTooltip {...providerHelp.phone} /></Form.Label>
                      <PhoneInput
country={values.countryIso ? values.countryIso.toLowerCase() : "in"}
  onlyCountries={["ae", "in"]}
  value={values.phone_number}
onChange={(value, data) => {
  const cleanedValue = value.replace(/\D/g, "");

  setFieldValue("phone_number", cleanedValue);

  const dialCode = data.dialCode;

  setFieldValue("countryIso", data.countryCode.toUpperCase());

  const matchedCountry = mapDialCodeToCountry(dialCode);

  if (matchedCountry) {
    setFieldValue("country_id", matchedCountry.id);

    fetchStates(matchedCountry.id);

    setFieldValue("state_id", "");
    setFieldValue("city_id", "");
  }

  setFieldTouched("phone_number", true, false);
}}
  onBlur={() => setFieldTouched("phone_number", true)}
  inputStyle={{
    width: "100%",
    height: "40px",
    backgroundColor: "#F8F9FA",
    borderColor:
      touched.phone_number && errors.phone_number
        ? "#dc3545"
        : "#E9ECEF",
  }}
  inputProps={{
    name: "phone_number",
    required: true,
  }}
/>
                        {touched.phone_number && errors.phone_number && (
                          <div className="invalid-feedback d-block">
                            {errors.phone_number}
                          </div>
                        )}
                        <div className="text-muted" style={{ fontSize: 12, marginTop: 4 }}>
                          This number is used to log in, so it must be unique.
                        </div>
                      </Form.Group>
                              <Form.Group className="mb-3">
                        <Form.Label>Country <FieldHelpTooltip {...providerHelp.country} /></Form.Label>
<AppDropdown
  value={values.country_id}
  options={countries.map(c => ({label: c.name || c.country_name, value: c.id ?? c.country_id}))}
  onChange={async (e) => {
    const countryId = e.value;
    setFieldValue("country_id", countryId);
    await fetchStates(countryId);
    setFieldValue("state_id", "");
    setFieldValue("city_id", "");
  }}
  placeholder="Select Country"
/>
</Form.Group>
   <Form.Group className="mb-3">
                        <Form.Label>State <FieldHelpTooltip {...providerHelp.state} /></Form.Label>
<AppDropdown
  value={values.state_id}
  options={states.map(s => ({label: s.name || s.state_name, value: s.id ?? s.state_id}))}
  onChange={async (e) => {
    const stateId = e.value;
    setFieldValue("state_id", stateId);
    await fetchCities(stateId);
    setFieldValue("city_id", "");
  }}
  placeholder="Select State"
/>
</Form.Group>
 <Form.Group className="mb-3">
                        <Form.Label>City <FieldHelpTooltip {...providerHelp.city} /></Form.Label>
<AppDropdown
  value={values.city_id}
  options={cities.map(c => ({label: c.name || c.city_name, value: c.id ?? c.city_id}))}
  onChange={(e) => setFieldValue("city_id", e.value)}
  placeholder="Select City"
/>
</Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Email <FieldHelpTooltip {...providerHelp.email} /></Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-input ${
                            touched.email && errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Enter email address"
                        />
                        {touched.email && errors.email && (
                          <div className="invalid-feedback d-block">
                            {errors.email}
                          </div>
                        )}
                      </Form.Group>
                    </div>
                    )}
                  </Form>
                  <div
                    className="custom-border-top p-4"
                    style={{
                      position: "sticky",
                      bottom: 0,
                      backgroundColor: "white",
                      display: "flex",
                      gap: "12px",
                    }}
                  >
                    <Button
                      variant="light"
                      onClick={onHide}
                      className="custom-radius btn-outline-borders"
                      style={{ flex: 1 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-custom-danger custom-radius"
                      style={{ flex: 1 }}
                      onClick={submitForm}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save Changes"}
                    </Button>
                  </div>
                </>
              )}
            </Formik>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    );
  };
  export default EditProfileSidebar;